export default __webpack_public_path__ + "static/media/rotate90.6dd8e54b.svg";